import { useNavigate } from "react-router-dom"
import { useCallback } from "react"

export const useNavigateWithParams = () => {
  const navigate = useNavigate()

  function navigateWithParams(
    path: string,
    params: Record<string, string> = {}
  ) {
    const queryString = new URLSearchParams(params).toString()
    navigate(`${path}?${queryString}`)
  }

  return useCallback(navigateWithParams, [navigate])
}
